import { useQuery } from '@tanstack/react-query';

import { conciergeClient } from '../api/concierge';
import { SupportHubEndpoints } from '../features/support-hub/api/constants';
import { GetZendeskWidgetSuccessResponse } from '../features/support-hub/api/types';
import { appConfig } from '../app/app-config';

export const useGetZendeskWidgetToken = () =>
    useQuery({
        enabled: appConfig.zendeskSsoEnabled,
        queryKey: ['zendesk-widget-token'],
        staleTime: 0,
        refetchInterval: Infinity,

        refetchOnWindowFocus: false,
        queryFn: async () => {
            const {
                data: { data },
            } = await conciergeClient.get<GetZendeskWidgetSuccessResponse>(
                SupportHubEndpoints.LIVE_CHAT
            );

            return data.token;
        },
        retry: 5,
        retryDelay: (attemptCount: number) => attemptCount * 1000,
    });
